import React from "react";
import { Badge } from "@shopify/polaris";
import type { PaymentDueDateStatus, PaymentStatus } from "../../../api_utils/types";

export default function PaymentStatusBadge({
  status,
}: {
  readonly status: PaymentStatus | PaymentDueDateStatus | null;
}): React.JSX.Element {
  if (status === null) return null;

  const tone =
    status === "Overdue" ? "critical" : status === "Unpaid" || status === "Partially paid" ? "attention" : undefined;

  return <Badge tone={tone}>{status}</Badge>;
}
